import { useRef } from 'react';

// Imports custom
import {
    CustomTableCheck
} from 'common'

export const TransactionTable = ({ useFetchInit }) => {

    const processingSelection = useRef(false);
    
    const {
        Forms,
        globalStates
    } = useFetchInit

    const { formOpeningMode} = globalStates

    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState, onInputChange } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    const isReadOnly = (formOpeningMode==='READONLY')

    const columnConfig = [
        {
            headerName: '',
            width: 60,
            checkboxSelection: !isReadOnly, // bloquea checks para mosodo read-only.
            headerCheckboxSelection: !isReadOnly, // bloquea checks para mosodo read-only.
            pinned: 'left',
            suppressMenu: true,
            sortable: false,
            filter: false,
            resizable: false
        },
        { field: 'aprobacion_fecha', headerName: 'F. APROBACION', minWidth: 200, filter: true },
        { field: 'credito', headerName: 'CREDITO', minWidth: 150, filter: true },
        // { field: 'idpago', headerName: 'ID PAGO', minWidth: 150, filter: true },
        { field: 'no_cuota', headerName: 'No. CUOTA', minWidth: 150, filter: true },
        { field: 'deposito_fecha', headerName: 'F. TRANSACCION', minWidth: 200,  filter: true },
        { field: 'idmovimiento', headerName: 'RECIBO', minWidth: 100, filter: true },
        // { field: 'deposito_monto', headerName: 'MONTO', minWidth: 150,  filter: true },
        { field: 'deposito_moneda', headerName: 'MONEDA', minWidth: 150,  filter: true },
        { field: 'deposito_tipo_cambio', headerName: 'T. CABMIO', minWidth: 150,  filter: true },
        {
            field: 'deposito_quetzal', headerName: 'TOTAL (Q)', minWidth: 150,  filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: 'deposito_dolares', headerName: 'TOTAL ($)', minWidth: 150,  filter: true,
            cellRenderer: (params) => '$ ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: 'movimiento_tipo', headerName: 'TIPO', minWidth: 150, filter: true,
            cellClass: (params) => {
                return params.value === 'EFECTIVO' ? 'bg-primary' : 'bg-secondary text-white';
            },
        },
        { field: 'caja', headerName: 'CAJA', minWidth: 350, filter: true },
        { field: 'banco', headerName: 'BANCO', minWidth: 350, filter: true },
        { field: 'boleta_numero', headerName: 'BOLETA', minWidth: 200,  filter: true },
    ]

    const handleRowSelected = (event) => {

        // Evita que el mismo evento se dispare en cascada
        if (processingSelection.current) return;

        processingSelection.current = true;

        const { api, node } = event;

        const currentIndex = node.rowIndex;
        const isSelected = node.isSelected();

        if (isSelected) {

            // Selecciona desde la fila actual hasta el final
            api.forEachNode((currentNode) => {

                if (currentNode.rowIndex >= currentIndex) {
                    currentNode.setSelected(true);
                }

            });

        } else {

            // Si se desmarca cualquier fila, limpiar toda la selección
            api.deselectAll();

        }

        // Actualiza el formulario
        onInputChange({
            target: {
                name: 'rowSelectedTransaction',
                value: api.getSelectedRows()
            }
        });

        processingSelection.current = false;

    };

    return (
        <div className='content'>
            <CustomTableCheck 
                // datos (listados, individuales)
                rowConfig={formState.transactions}
                columnConfig={columnConfig}

                // handleClicks
                // onRowSelected={
                //     (event)=>onInputChange({
                //         target: { 
                //             name: 'rowSelectedTransaction', 
                //             value: event.api.getSelectedRows(),
                //         }
                //     })
                // }

                onRowSelected={handleRowSelected}
            />
        </div>
    )
}
